// extracted by mini-css-extract-plugin
export default {"header":"vk_kKP6x"};